import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import axios from "axios";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../src/styles/HolidayEventStyle.css";

const contentStyle2 = {
  height: "200px",
  //   color: "black",
  //   lineHeight: "160px",
  textAlign: "left",
  //   background: "white",
  //   margin: "10px",
  // justifyContent: "fit",
};
const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 45,
      color: "rgb(0,176,240)",
    }}
    spin
  />
);

const HolidayEvent = () => {
  const [holidayData, setHolidayData] = useState([]);
  const base_url = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [modalVisible, setModalVisible] = useState(false);
  //   const [selectedEvent, setSelectedEvent] = useState(null);

  const handleModal = () => {
    setModalVisible(!modalVisible);
  };
  
  const holidayCalender = () => {
    navigate("/holiday-calender");
  }

  const closeModal = () => {
    setModalVisible(false);
    // console.log("clicked ", modalVisible);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const accessToken = sessionStorage.getItem("accessToken");
        const user_id = sessionStorage.getItem("userData");

        const response = await axios.get(
          `${base_url}/api/v1/client/holiday/getAllHolidaysForClient`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );

        const { data } = response;
        // console.log(data.data.length)
        setHolidayData(data.data);
        // console.log(holidayData.length)
      } catch (error) {
        // console.log(error);
        // Handle error state or display an error message
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1200);
      }
    };

    const debouncedFetchData = debounce(fetchData, 200); // Adjust the debounce delay as needed
    debouncedFetchData();
    return () => {
      // Cancel the debounced function when the component unmounts
      debouncedFetchData.cancel();
    };
  }, []);

  // Function to format the date
  function formatDate(dateString) {
    const options = { day: "numeric", month: "short" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
  }

  return (
    <>
      {loading ? (
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100px",
          }}
        >
          <Spin
            size="large"
            indicator={antIcon}
            style={{ marginLeft: "10px", marginTop: "67px" }}
          >
            <div className="content" style={{ paddingTop: "40px" }} />
          </Spin>
        </div>
      ) : (
        <div title="Click to see all Upcoming Holidays" className="holidayEventCard">
          {holidayData.length > 0 && (
            <div style={{ flex: "1" }}>
              
              <span style={{display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end", marginBottom: "20px"}} onClick={holidayCalender}>
                <strong className="holidayTitle">Upcoming Holidays</strong>
                <strong className="holidaydisplay">
                  {holidayData[0].date}, {holidayData[0].weekDay} <b> | </b> {" "}
                  {holidayData[0].holiday_name.split("|").join(", ")}
                </strong>
              </span>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default HolidayEvent;
